/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { alpha, Theme } from "@mui/material";

const radioPadStyle = {
  input: {
    display: "none",
  },
  wrapper: {
    width: "100%",
    margin: "1rem auto",
    textAlign: "center",
    display: "block",
  },
  wrapperMaxWidth: {
    maxWidth: "550px",
  },
  paper: (theme: Theme) => ({
    cursor: "pointer",
    padding: "1rem",
    border: "2px solid",
    borderColor: theme.palette.divider,
  }),
  labelIcon: {
    paddingTop: "0.5rem",
    "& svg": { fontSize: "3rem" },
  },
  labelText: {
    padding: "1rem",
  },
  activeColor: (theme: Theme)=> ({
    color: theme.palette.primary.main,
  }),
  activePad: (theme: Theme) => ({
    background: alpha(theme.palette.primaryPale, 0.25),
    borderColor: theme.palette.primary.main,
  }),
  errorPad: (theme: Theme) => ({
    borderColor: theme.palette.error.main,
  }),
};

export default radioPadStyle;
